import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-be09aac4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-filter" }
const _hoisted_2 = { class: "form-block" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-block-title" }, " Создание наименования рекламной кампании ", -1))
const _hoisted_4 = { class: "flex some-inputs" }
const _hoisted_5 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Бренд", -1))
const _hoisted_7 = { class: "flex flex-col input-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Магазин", -1))
const _hoisted_9 = { class: "flex some-inputs m-t-8" }
const _hoisted_10 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Стратегия", -1))
const _hoisted_12 = { class: "flex flex-col input-container" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Дополнительное поле", -1))
const _hoisted_14 = { class: "flex some-inputs m-t-8" }
const _hoisted_15 = { class: "flex flex-col m-r-8 input-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Период запуска рекламной кампании от", -1))
const _hoisted_17 = { class: "flex flex-col input-container" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Период запуска рекламной кампании до", -1))
const _hoisted_19 = { class: "flex flex-col fl-1 m-t-8" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Название рекламной кампании", -1))
const _hoisted_21 = { class: "form-block-title flex fl-jc-sb" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "План трафика", -1))
const _hoisted_23 = { class: "flex" }
const _hoisted_24 = { class: "m-r-12" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-name" }, "CTR план:", -1))
const _hoisted_26 = { class: "m-r-12" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-name" }, "CPC план: ", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label-name" }, "CPM план: ", -1))
const _hoisted_29 = { class: "flex some-inputs" }
const _hoisted_30 = { class: "flex flex-col fl-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Рекламная площадка", -1))
const _hoisted_32 = { class: "flex fl-1 m-t-8 flex-end" }
const _hoisted_33 = { class: "flex flex-col fl-1 m-r-12" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Показы план", -1))
const _hoisted_35 = { class: "flex flex-col fl-1 m-r-12" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Клики план", -1))
const _hoisted_37 = { class: "flex flex-col fl-1 m-r-12" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Бюджет план (без НДС), ₽", -1))
const _hoisted_39 = { class: "flex flex-col fl-1 m-r-12" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "name",
  class: "small-label"
}, "Охват план", -1))
const _hoisted_41 = { class: "group-button-container flex" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash" }, null, -1))
const _hoisted_44 = [
  _hoisted_43
]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-plus" }, null, -1))
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-l-10" }, "План", -1))
const _hoisted_48 = [
  _hoisted_46,
  _hoisted_47
]

import { ref, watch, onMounted, computed } from "vue";
import { useRoute, useRouter } from "vue-router";

import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import CatalogDataSingleInput from "@/widgets/forms/CatalogDataSingleInput.vue";
import CalendarBaseInput from "@/shared/forms/CalendarBaseInput.vue";
import SceletonInput from "@/shared/forms/SceletonInput.vue";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import DuplicatedTraficPlanDialog from "@/shared/dialogs/DuplicatedTraficPlanDialog.vue";

import { Brand } from "@/store/catalog_data/brands";
import { Shop } from "@/store/catalog_data/shops";
import { useCampaignStore } from "@/store/campaigns/campaigns";
import { usePlatformsDictionaryStore } from "@/store/catalog_data/platforms";
import {
  getCampaignName,
  isCampaignNameValidated,
  isTraficPlanFilled,
  prepareModelWithTraficToServer,
  convertServerToModelWithTraficPlan,
  calcCPC,
  calcCPM,
  calcCTR,
  roundToTwoDecimalPlaces,
  hasUniquePlatformSlugs,
} from "@/services/campaigns/utils";
import { rootGetters } from "@/main";


export default /*#__PURE__*/_defineComponent({
  __name: 'PlanTraficCreateForm',
  props: {
    isLoading: { type: Boolean }
  },
  emits: ["setCreateButton", "setLoading"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const emit = __emit;


const route = useRoute();
const router = useRouter();
const store = useCampaignStore();
const platformsStore = usePlatformsDictionaryStore();
const isNameFilled = ref(false);
const isInvalidForm = ref(false);
const confirmVisible = ref({
  duplicate: false,
});
const isLoadingData = ref(false);

const duplicatedId = ref(0);
const useNameDefault = ref(false);
const nameDefault = ref(null);
const isLoadedFirst = ref(true);

const campaign = ref({
  brand: null as Brand | null,
  shop: null as Shop | null,
  name: "",
  strategy: "",
  extra_info: "",
  date_from: null as Date | null,
  date_to: null as Date | null,
  traffic_plans: [
    {
      plan_click: null as number | null,
      plan_impressions: null as number | null,
      plan_reach: null as number | null,
      plan_cost: null as number | null,
      platform_slug: null as string | null,
    },
  ],
});

const campaignWatchFields = computed(() => ({
  brand: campaign.value.brand,
  shop: campaign.value.shop,
  name: campaign.value.name,
  strategy: campaign.value.strategy,
  extra_info: campaign.value.extra_info,
  date_from: campaign.value.date_from,
  date_to: campaign.value.date_to,
}));

const isCampaignSetted = computed(() => {
  return Boolean(route.params.id);
});

const campaignName = computed(() => {
  return getCampaignName(campaign.value, useNameDefault.value);
});

const platforms = computed(() => {
  const platforms: string[] = [];
  campaign.value.traffic_plans.forEach((el) => {
    if (el.platform_slug && !platforms.includes(el.platform_slug)) {
      platforms.push(el.platform_slug);
    }
  });
  return platforms;
});

const reload = () => {
  if (isCampaignSetted.value || store.duplicateCampaignId) {
    isLoadingData.value = true;
    const campaignId = parseInt(route.params.id) || store.duplicateCampaignId;
    store
      .getCampaign(campaignId)
      .then((campaignClone) => {
        if (campaignClone) {
          campaign.value = convertServerToModelWithTraficPlan(campaignClone);
          if (store.addedTraficPlans.length > 0 && route.query.union == "t") {
            campaign.value.traffic_plans = campaign.value.traffic_plans.concat(
              store.addedTraficPlans
            );
          }
          store.addedTraficPlans = [];
          useNameDefault.value = true;
          isLoadedFirst.value = true;
          nameDefault.value = JSON.parse(JSON.stringify(campaign.value));
        }
        if (store.duplicateCampaignId) {
          const extraValue = campaign.value.extra_info
            ? campaign.value.extra_info
            : "";
          campaign.value.extra_info = extraValue + "копия";
          store.duplicateCampaignId = 0;
        }
      })
      .finally(() => {
        isLoadingData.value = false;
      });
  }
};

onMounted(() => {
  reload();
});

watch(
  () => campaignName.value,
  () => {
    isNameFilled.value = isCampaignNameValidated(campaign.value);
  }
);

watch(
  () => route.params.id,
  () => {
    reload();
  }
);

watch(campaignWatchFields, (newValue) => {
  if (nameDefault.value) {
    if (
      (!isLoadedFirst.value || store.duplicateCampaignId) &&
      useNameDefault.value &&
      (newValue.extra_info !== nameDefault.value.extra_info ||
        newValue.brand !== nameDefault.value.brand ||
        newValue.shop !== nameDefault.value.shop ||
        newValue.strategy !== nameDefault.value.strategy ||
        newValue.date_from !== nameDefault.value.date_from ||
        newValue.date_to !== nameDefault.value.date_to)
    ) {
      useNameDefault.value = false;
    }
  }
  if (useNameDefault.value != undefined) isLoadedFirst.value = false;
});

const addPlan = (idx: number) => {
  campaign.value.traffic_plans.splice(idx + 1, 0, {
    plan_click: null as number | null,
    plan_impressions: null as number | null,
    plan_reach: null as number | null,
    plan_cost: null as number | null,
    platform_slug: null as string | null,
  });
};

const deletePlan = (idx: number) => {
  campaign.value.traffic_plans.splice(idx, 1);
};

const createTraficPlan = () => {
  if (!isNameFilled.value || !isTraficPlanFilled(campaign.value)) {
    isInvalidForm.value = true;
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Проверьте, что все необходимые поля заполнены и наименования бренда и магазина не содержат нижнее подчеркивание.`
    );
    return;
  } else if (!hasUniquePlatformSlugs(campaign.value)) {
    rootGetters.toast.show(
      "warn",
      "Ошибка сохранения",
      `Нельзя создавать несколько планов для одной и той же платформы. Необходимо убрать повторяющиеся платформы из списка.`
    );
    return;
  }
  campaign.value.name = campaignName.value;
  const campaignForCreation = prepareModelWithTraficToServer(campaign.value);
  if (campaignForCreation) {
    emit("setLoading", true);
    if (isCampaignSetted.value) {
      performCampaignAction(() =>
        store.updateCampaignWithTraficPlan(
          campaignForCreation,
          parseInt(route.params.id)
        )
      );
    } else {
      performCampaignAction(() =>
        store.createCampaignWithTraficPlan(campaignForCreation)
      );
    }
  }
};

const performCampaignAction = (action: any) => {
  const handleCampaignSuccess = () => {
    router.push({ name: "traficPlanList" });
    setTimeout(() => {
      store.activeFirst = false;
    }, 5000);
  };

  const handleCampaignError = (err: any) => {
    if (err.response && err.response.status == 409)
      store.getCampaignByName(campaign.value.name).then((id) => {
        if (id) {
          duplicatedId.value = id;
          confirmVisible.value.duplicate = true;
          store.addedTraficPlans = campaign.value.traffic_plans;
        }
      });
  };

  action()
    .then(handleCampaignSuccess)
    .catch(handleCampaignError)
    .finally(() => {
      emit("setLoading", false);
    });
};

const getMessage = (isNameFilled: boolean) => {
  if (isNameFilled) return "Наименование рекламной кампании корректно";
  return "Наименование рекламной кампании некорректно";
};

__expose({
  createTraficPlan,
});

return (_ctx: any,_cache: any) => {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(CatalogDataSingleInput, {
                selectType: "brand",
                "is-invalid": isInvalidForm.value && campaign.value.brand == null,
                isSegmentSetted: false,
                modelValue: campaign.value.brand,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (campaign.value.brand = $event))
              }, null, 8, ["is-invalid", "modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(CatalogDataSingleInput, {
                selectType: "shop",
                "is-invalid": isInvalidForm.value && campaign.value.shop == null,
                isSegmentSetted: false,
                modelValue: campaign.value.shop,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (campaign.value.shop = $event))
              }, null, 8, ["is-invalid", "modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: campaign.value.strategy,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((campaign.value.strategy) = $event)),
                disabled: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(_unref(InputText), {
                placeholder: "Введите значение",
                modelValue: campaign.value.extra_info,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((campaign.value.extra_info) = $event)),
                disabled: false
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(CalendarBaseInput, {
                modelValue: campaign.value.date_from,
                "is-invalid": isInvalidForm.value && campaign.value.date_from == null,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (campaign.value.date_from = $event)),
                disabled: false
              }, null, 8, ["modelValue", "is-invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
            default: _withCtx(() => [
              _createVNode(CalendarBaseInput, {
                "min-date": new Date(),
                modelValue: campaign.value.date_to,
                "is-invalid": isInvalidForm.value && campaign.value.date_to == null,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (campaign.value.date_to = $event)),
                disabled: false
              }, null, 8, ["min-date", "modelValue", "is-invalid"])
            ]),
            _: 1
          }, 8, ["is-loading"])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _hoisted_20,
        _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
          default: _withCtx(() => [
            _createVNode(_unref(IconField), null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_unref(InputIcon), {
                  class: _normalizeClass(["pi", 
                isNameFilled.value
                  ? 'pi-check-circle violete'
                  : 'pi-exclamation-circle red'
              ])
                }, null, 8, ["class"]), [
                  [_directive_tooltip, {
                value: getMessage(isNameFilled.value),
                class: 'white-tooltip',
              }]
                ]),
                _createVNode(_unref(InputText), {
                  class: "campaign-name",
                  placeholder: "Введите название",
                  modelValue: campaignName.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((campaignName).value = $event)),
                  disabled: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-loading"])
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campaign.value.traffic_plans, (plan, idx) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["form-block", [idx != campaign.value.traffic_plans.length - 1 ? 'hidden' : '']]),
        key: `traffic-plans-${idx}`
      }, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createTextVNode(" " + _toDisplayString(_unref(roundToTwoDecimalPlaces)(
                _unref(calcCTR)(plan.plan_click, plan.plan_impressions)
              )) + " % ", 1)
            ]),
            _createElementVNode("div", _hoisted_26, [
              _hoisted_27,
              _createTextVNode(" " + _toDisplayString(_unref(roundToTwoDecimalPlaces)(_unref(calcCPC)(plan.plan_click, plan.plan_cost))) + " ₽ ", 1)
            ]),
            _createElementVNode("div", null, [
              _hoisted_28,
              _createTextVNode(" " + _toDisplayString(_unref(roundToTwoDecimalPlaces)(
                _unref(calcCPM)(plan.plan_impressions, plan.plan_cost)
              )) + " ₽ ", 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _hoisted_31,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(CatalogDataSingleInput, {
                  "not-search": true,
                  "use-id-only": true,
                  selectType: "platform",
                  "is-invalid": isInvalidForm.value && plan.platform_slug == null,
                  isSegmentSetted: false,
                  modelValue: plan.platform_slug,
                  "onUpdate:modelValue": ($event) => (plan.platform_slug = $event),
                  "filter-field": "slug",
                  "filter-list": platforms.value
                }, null, 8, ["is-invalid", "modelValue", "onUpdate:modelValue", "filter-list"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ])
        ]),
        _createElementVNode("div", _hoisted_32, [
          _createElementVNode("div", _hoisted_33, [
            _hoisted_34,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputNumber), {
                  placeholder: "Введите значение",
                  modelValue: plan.plan_impressions,
                  "onUpdate:modelValue": ($event: any) => ((plan.plan_impressions) = $event),
                  maxFractionDigits: 2,
                  invalid: isInvalidForm.value && plan.plan_impressions == null
                }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputNumber), {
                  placeholder: "Введите значение",
                  modelValue: plan.plan_click,
                  "onUpdate:modelValue": ($event: any) => ((plan.plan_click) = $event),
                  maxFractionDigits: 2,
                  invalid: isInvalidForm.value && plan.plan_impressions == null
                }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputNumber), {
                  placeholder: "Введите значение",
                  modelValue: plan.plan_cost,
                  "onUpdate:modelValue": ($event: any) => ((plan.plan_cost) = $event),
                  maxFractionDigits: 2,
                  invalid: isInvalidForm.value && plan.plan_impressions == null
                }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_39, [
            _hoisted_40,
            _createVNode(SceletonInput, { "is-loading": isLoadingData.value }, {
              default: _withCtx(() => [
                _createVNode(_unref(InputNumber), {
                  placeholder: "Введите значение",
                  modelValue: plan.plan_reach,
                  "onUpdate:modelValue": ($event: any) => ((plan.plan_reach) = $event),
                  maxFractionDigits: 2,
                  invalid: isInvalidForm.value && plan.plan_impressions == null
                }, null, 8, ["modelValue", "onUpdate:modelValue", "invalid"])
              ]),
              _: 2
            }, 1032, ["is-loading"])
          ]),
          _createElementVNode("div", _hoisted_41, [
            (campaign.value.traffic_plans.length > 1)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "delete-button flex flex-center",
                  onClick: ($event: any) => (deletePlan(idx))
                }, _hoisted_44, 8, _hoisted_42))
              : _createCommentVNode("", true),
            (
              _unref(platformsStore).itemList.length > campaign.value.traffic_plans.length
            )
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "group-button flex flex-center",
                  onClick: ($event: any) => (addPlan(idx))
                }, _hoisted_48, 8, _hoisted_45))
              : _createCommentVNode("", true)
          ])
        ])
      ], 2))
    }), 128)),
    _createVNode(DuplicatedTraficPlanDialog, {
      id: duplicatedId.value,
      visible: confirmVisible.value.duplicate,
      onClose: _cache[7] || (_cache[7] = ($event: any) => (confirmVisible.value.duplicate = false))
    }, null, 8, ["id", "visible"])
  ]))
}
}

})